module.exports = __webpack_public_path__ + "./fonts/5673da52c98bb6cb33ada5aaf649703e.ttf";